<template>
  <UiModal
    v-if="ls.viewItemStatus === 'loading'"
    v-model="showLoading"
    :title="`${$t('feedback.loading')}...`"
    :width="400"
    hide-footer
    hide-close
    disable-esc
  >
    <div class="flex items-center justify-center py-8">
      <UiLoader size="40px" class="mr-3" />
    </div>
  </UiModal>
  <LearningDetail
    v-if="ls.activeItem?.id && ['course', 'trail'].includes(ls.activeItem?.type)"
    v-model="visible"
    :id="ls.activeItem?.id"
    :type="ls.activeItem?.type"
  />
  <MediaDetail
    v-else-if="ls.activeItem?.id && ls.activeItem?.type === 'media'"
    v-model="visible"
    :id="ls.activeItem?.id"
  />
</template>

<script setup lang="ts">
import { computed, nextTick, onUnmounted, watch } from 'vue'
import { learnUrl } from '@/common/util'
import { useLearningStore } from '@/stores/learningStore'

import UiModal from '@/components/ui/modal.vue'
import UiLoader from '@/components/ui/loader.vue'

import LearningDetail from './components/learningDetail.vue'
import MediaDetail from './components/mediaDetail.vue'

defineOptions({
  name: 'ItemDetail'
})

const ls = useLearningStore()
const showLoading = computed(() => ls.viewItemStatus === 'loading')

const visible = computed({
  get: () => !!ls.activeItem?.id,
  set: (v) => {
    if (!v) {
      ls.interruptItem()
      const url = new URL(window.location.href)
      url.searchParams.delete('view')
      window.history.replaceState({}, document.title, url.toString())
    }
  }
})

watch(
  () => ls.activeItem?.id,
  (newId) => {
    if (newId) {
      nextTick(() => {
        if (visible.value) {
          const url = new URL(window.location.href)
          url.searchParams.set('view', learnUrl.encode(ls.activeItem?.type || '', newId))
          window.history.replaceState({}, document.title, url.toString())
        }
      })
    }
  },
  { immediate: true }
)

onUnmounted(() => {
  ls.closeItem()
})
</script>
